"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.List = exports.LIST_TYPES = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../utils/constants");
var _ListGroup = require("./_ListGroup");
var _ListItem = require("./_ListItem");
var _ListContext = require("./_ListContext");
var _List = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List.css") : void 0);
var _excluded = ["bordered", "children", "className", "size", "type"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-list';
var LIST_TYPES = exports.LIST_TYPES = ['ordered', 'unordered'];

/**
 * The **List** component can be used to display a homogeneous set of basic data
 * with a single-level hierarchy.
 */

var List = exports.List = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _context;
  var bordered = props.bordered,
    children = props.children,
    className = props.className,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    _props$type = props.type,
    type = _props$type === void 0 ? 'unordered' : _props$type,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_List.default);
  var isUsingGroups = _react.default.Children.toArray(children).some(function (child) {
    var _child$type;
    return (child === null || child === void 0 || (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'List.Group';
  });
  var listContextValue = (0, _react.useMemo)(function () {
    return {
      bordered: bordered,
      isUsingGroups: isUsingGroups,
      size: size,
      type: type
    };
  }, [bordered, isUsingGroups, size, type]);
  var classes = classnames(CSS_BLOCK, className, (0, _defineProperty2.default)({}, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, size), !!size));
  return /*#__PURE__*/_react.default.createElement(_ListContext.ListContext.Provider, {
    value: listContextValue
  }, /*#__PURE__*/_react.default.createElement(_ListGroup.ListGroup, (0, _extends2.default)({}, otherProps, {
    className: classes,
    isRoot: true,
    ref: ref
  }), children));
});
List.displayName = 'List';
List.propTypes = _objectSpread(_objectSpread({}, _ListGroup.ListGroup.propTypes), {}, {
  /** Set to `true` to add bottom borders to list items. */
  bordered: _propTypes.default.bool,
  /** Size of the element. Options are `'lg'`, `'md'`. */
  size: _propTypes.default.oneOf(_constants.CONTROL_SIZES),
  /** Type of list to render. Options are `'ordered'`, `'unordered'`. */
  type: _propTypes.default.oneOf(LIST_TYPES)
});
List.Group = _ListGroup.ListGroup;
List.Item = _ListItem.ListItem;
var _default = exports.default = List;